import { ChevronDown, ChevronRight } from "lucide-react";
import { msg } from "@lingui/core/macro";
import { Button } from "@/components/ui/button";
import type { Row } from "@tanstack/react-table";
import { i18n } from "@/lib/i18n";

interface ExpandCellProps<TData> {
  row: Row<TData>;
}

export function ExpandCell<TData>({ row }: ExpandCellProps<TData>) {
  if (!row.getCanExpand()) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-7 w-7"
      onClick={row.getToggleExpandedHandler()}
      aria-label={row.getIsExpanded() ? i18n._(msg`Collapse`) : i18n._(msg`Expand`)}
    >
      {row.getIsExpanded() ? (
        <ChevronDown className="h-4 w-4" />
      ) : (
        <ChevronRight className="h-4 w-4" />
      )}
    </Button>
  );
}
